import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  constructor() { }
  @Input() collapsedSidebar: boolean = false
  @Output() toggleContainer: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Output() toggleSidebarTest: EventEmitter<boolean> = new EventEmitter();
  @Output() openSideBarChange: EventEmitter<boolean> = new EventEmitter();
  @Input() toggleMenu:any = ()=>{}
  isCollapsed: boolean = this.collapsedSidebar
  collapse = () => {
    this.isCollapsed = !this.isCollapsed
    this.toggleContainer.emit(this.isCollapsed)
  }

  // active = route

  // ngOnInit(): void {
  //   this.getActivePage(window.location.pathname)
  // }

  // getActivePage = (route: string) => {
  //   if (route === "/dashboard") this.path = "dashboard"
  //   else if (route.includes("settlement-accounts")) this.path = "settlement-accounts"
  //   else if (route.includes("locations")) this.path = "locations"
  //   else if (route.includes("transactions")) this.path = "transactions"
  //   else if (route.includes("settings")) this.path = "settings"
  //   else this.path = ""
  // }
  toggleSidebar_() {
    // this.openSideBar = !this.openSideBar;
    // this.openSideBarChange.emit(this.openSideBar);
    // console.log("click")
    this.toggleSidebarTest.emit();
    this.toggleMenu()
  }

}
